/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AjustarDto,
  CreditarDto,
  ErroResponse,
  ExtratoResponse,
  LancamentoResponse,
  PaginaDeSaldosResponse,
  UnidadesAdminControllerExtratoParams,
  UnidadesAdminControllerListarParams
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getUnidadesAdminControllerListarUrl = (params?: UnidadesAdminControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/unidades?${stringifiedParams}` : `/v1/admin/unidades`
}

/**
 * @summary Saldo de unidades por ambiente, paginado
 */
export const unidadesAdminControllerListar = async (params?: UnidadesAdminControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeSaldosResponse> => {

  return httpClient<PaginaDeSaldosResponse>(getUnidadesAdminControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUnidadesAdminControllerListarQueryKey = (params?: UnidadesAdminControllerListarParams,) => {
    return [
    `/v1/admin/unidades`, ...(params ? [params] : [])
    ] as const;
    }


export const getUnidadesAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError = ErroResponse>(params?: UnidadesAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUnidadesAdminControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof unidadesAdminControllerListar>>> = ({ signal }) => unidadesAdminControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UnidadesAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof unidadesAdminControllerListar>>>
export type UnidadesAdminControllerListarQueryError = ErroResponse


export function useUnidadesAdminControllerListar<TData = Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError = ErroResponse>(
 params: undefined |  UnidadesAdminControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof unidadesAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof unidadesAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnidadesAdminControllerListar<TData = Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError = ErroResponse>(
 params?: UnidadesAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof unidadesAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof unidadesAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnidadesAdminControllerListar<TData = Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError = ErroResponse>(
 params?: UnidadesAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Saldo de unidades por ambiente, paginado
 */

export function useUnidadesAdminControllerListar<TData = Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError = ErroResponse>(
 params?: UnidadesAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUnidadesAdminControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUnidadesAdminControllerExtratoUrl = (tenantId: string,
    params?: UnidadesAdminControllerExtratoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/unidades/${tenantId}/extrato?${stringifiedParams}` : `/v1/admin/unidades/${tenantId}/extrato`
}

/**
 * @summary Extrato do ambiente: todo lançamento que compõe o saldo
 */
export const unidadesAdminControllerExtrato = async (tenantId: string,
    params?: UnidadesAdminControllerExtratoParams, options?: Parameters<typeof httpClient>[1]): Promise<ExtratoResponse> => {

  return httpClient<ExtratoResponse>(getUnidadesAdminControllerExtratoUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUnidadesAdminControllerExtratoQueryKey = (tenantId: string,
    params?: UnidadesAdminControllerExtratoParams,) => {
    return [
    `/v1/admin/unidades/${tenantId}/extrato`, ...(params ? [params] : [])
    ] as const;
    }


export const getUnidadesAdminControllerExtratoQueryOptions = <TData = Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError = ErroResponse>(tenantId: string,
    params?: UnidadesAdminControllerExtratoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUnidadesAdminControllerExtratoQueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>> = ({ signal }) => unidadesAdminControllerExtrato(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UnidadesAdminControllerExtratoQueryResult = NonNullable<Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>>
export type UnidadesAdminControllerExtratoQueryError = ErroResponse


export function useUnidadesAdminControllerExtrato<TData = Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError = ErroResponse>(
 tenantId: string,
    params: undefined |  UnidadesAdminControllerExtratoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>,
          TError,
          Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnidadesAdminControllerExtrato<TData = Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError = ErroResponse>(
 tenantId: string,
    params?: UnidadesAdminControllerExtratoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>,
          TError,
          Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnidadesAdminControllerExtrato<TData = Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError = ErroResponse>(
 tenantId: string,
    params?: UnidadesAdminControllerExtratoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Extrato do ambiente: todo lançamento que compõe o saldo
 */

export function useUnidadesAdminControllerExtrato<TData = Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError = ErroResponse>(
 tenantId: string,
    params?: UnidadesAdminControllerExtratoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unidadesAdminControllerExtrato>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUnidadesAdminControllerExtratoQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUnidadesAdminControllerCreditarUrl = (tenantId: string,) => {




  return `/v1/admin/unidades/${tenantId}/creditar`
}

/**
 * @summary Credita unidades. A descrição é obrigatória — é o rastro.
 */
export const unidadesAdminControllerCreditar = async (tenantId: string,
    creditarDto: CreditarDto, options?: Parameters<typeof httpClient>[1]): Promise<LancamentoResponse> => {

  return httpClient<LancamentoResponse>(getUnidadesAdminControllerCreditarUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(creditarDto)
  }
);}





export const getUnidadesAdminControllerCreditarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unidadesAdminControllerCreditar>>, TError,{tenantId: string;data: CreditarDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof unidadesAdminControllerCreditar>>, TError,{tenantId: string;data: CreditarDto}, TContext> => {

const mutationKey = ['unidadesAdminControllerCreditar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unidadesAdminControllerCreditar>>, {tenantId: string;data: CreditarDto}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  unidadesAdminControllerCreditar(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnidadesAdminControllerCreditarMutationResult = NonNullable<Awaited<ReturnType<typeof unidadesAdminControllerCreditar>>>
    export type UnidadesAdminControllerCreditarMutationBody = CreditarDto
    export type UnidadesAdminControllerCreditarMutationError = unknown

    /**
 * @summary Credita unidades. A descrição é obrigatória — é o rastro.
 */
export const useUnidadesAdminControllerCreditar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unidadesAdminControllerCreditar>>, TError,{tenantId: string;data: CreditarDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unidadesAdminControllerCreditar>>,
        TError,
        {tenantId: string;data: CreditarDto},
        TContext
      > => {
      return useMutation(getUnidadesAdminControllerCreditarMutationOptions(options), queryClient);
    }
    export const getUnidadesAdminControllerAjustarUrl = (tenantId: string,) => {




  return `/v1/admin/unidades/${tenantId}/ajustar`
}

/**
 * @summary Ajuste manual, positivo ou negativo. É o caminho de correção do ledger.
 */
export const unidadesAdminControllerAjustar = async (tenantId: string,
    ajustarDto: AjustarDto, options?: Parameters<typeof httpClient>[1]): Promise<LancamentoResponse> => {

  return httpClient<LancamentoResponse>(getUnidadesAdminControllerAjustarUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ajustarDto)
  }
);}





export const getUnidadesAdminControllerAjustarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unidadesAdminControllerAjustar>>, TError,{tenantId: string;data: AjustarDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof unidadesAdminControllerAjustar>>, TError,{tenantId: string;data: AjustarDto}, TContext> => {

const mutationKey = ['unidadesAdminControllerAjustar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unidadesAdminControllerAjustar>>, {tenantId: string;data: AjustarDto}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  unidadesAdminControllerAjustar(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnidadesAdminControllerAjustarMutationResult = NonNullable<Awaited<ReturnType<typeof unidadesAdminControllerAjustar>>>
    export type UnidadesAdminControllerAjustarMutationBody = AjustarDto
    export type UnidadesAdminControllerAjustarMutationError = ErroResponse

    /**
 * @summary Ajuste manual, positivo ou negativo. É o caminho de correção do ledger.
 */
export const useUnidadesAdminControllerAjustar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unidadesAdminControllerAjustar>>, TError,{tenantId: string;data: AjustarDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unidadesAdminControllerAjustar>>,
        TError,
        {tenantId: string;data: AjustarDto},
        TContext
      > => {
      return useMutation(getUnidadesAdminControllerAjustarMutationOptions(options), queryClient);
    }
